import i18n from '../../locales/index'
import Main from './main.vue'
export default Main
